<template>
  <div>
    来店者割合
    <el-form :model="form" inline>
      <el-switch
        v-model="form.multiple"
        active-text="範囲指定"
        inactive-text="単月指定" />
      <el-date-picker
        v-model="form.targetMonth"
        :clearable="false"
        type="month">
      </el-date-picker>
      <div style="display: inline;" v-show="form.multiple"> 〜
        <el-date-picker
          v-model="form.toTargetMonth"
          :clearable="false"
          type="month">
        </el-date-picker>
      </div>
      <el-select v-model="form.shop">
        <el-option
          v-if="groupPk"
          label="全店舗"
          :value="groupPk" />
        <el-option
          v-for="shop in shops"
          :key="shop.pk"
          :label="shop.name"
          :value="shop.pk">
        </el-option>
      </el-select>
      <el-button
        type="primary"
        :disabled="!form.shop || isLoading"
        @click="fetchData(false)">表示</el-button>
      <el-button
        type="success"
        :disabled="!form.shop || isLoading"
        @click="fetchData(true)">再集計</el-button>
      <el-button
        :disabled="!items.length || isLoading"
        icon="el-icon-download"
        type="warning"
        @click="download">ダウンロード</el-button>
    </el-form>
    <el-form :model="narrowForm" inline>
      <el-checkbox v-model="narrowForm.showCount">数量を表示</el-checkbox>
      <el-checkbox v-model="narrowForm.showRate">割合を表示</el-checkbox>
      <el-checkbox v-model="narrowForm.showShort">45日以内</el-checkbox>
      <el-checkbox v-model="narrowForm.showMiddle">90日以内</el-checkbox>
      <el-checkbox v-model="narrowForm.showLong">90日超過</el-checkbox>
    </el-form>
    <div class="data-area" v-bind:style="dataAreaStyle">
      <el-table
        ref="table"
        :data="items"
        height="100%"
        stripe
        border
        show-summary
        :summary-method="getSummaries"
        v-loading="isLoading">
        <el-table-column
          prop="date"
          label="日付"
          width="100"
          fixed="left">
          <template slot-scope="scope">
            <div>
              {{ scope.row.date|printDate }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="reservationCount"
          label="予約数"
          width="70"
          align="right">
        </el-table-column>
        <el-table-column
          prop="repeatRate"
          label="リピート率"
          width="95"
          align="right"
          :formatter="rateFormatter">
        </el-table-column>
        <el-table-column
          label="合計"
          align="center">
          <el-table-column
            v-if="narrowForm.showCount && narrowForm.showShort"
            prop="shortRepeat"
            label="45日以内"
            width="90"
            align="right">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showCount && narrowForm.showMiddle"
            prop="middleRepeat"
            label="90日以内"
            width="90"
            align="right">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showCount && narrowForm.showLong"
            prop="longRepeat"
            label="90日超過"
            width="90"
            align="right">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showRate && narrowForm.showShort"
            prop="shortRepeatRate"
            label="45日以内(率)"
            width="110"
            align="right"
            :formatter="rateFormatter">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showRate && narrowForm.showMiddle"
            prop="middleRepeatRate"
            label="90日以内(率)"
            width="110"
            align="right"
            :formatter="rateFormatter">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showRate && narrowForm.showLong"
            prop="longRepeatRate"
            label="90日超過(率)"
            width="110"
            align="right"
            :formatter="rateFormatter">
          </el-table-column>
        </el-table-column>
        <el-table-column
          label="初回来店"
          align="center">
          <el-table-column
            v-if="narrowForm.showCount"
            prop="firstVisitor"
            label="初回来店合計"
            width="110"
            align="right">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showCount && narrowForm.showShort"
            prop="firstShortRepeat"
            label="45日以内"
            width="90"
            align="right">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showCount && narrowForm.showMiddle"
            prop="firstMiddleRepeat"
            label="90日以内"
            width="90"
            align="right">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showCount && narrowForm.showLong"
            prop="firstLongRepeat"
            label="90日超過"
            width="90"
            align="right">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showRate && narrowForm.showShort"
            prop="firstShortRepeatRate"
            label="45日以内(率)"
            width="110"
            align="right"
            :formatter="rateFormatter">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showRate && narrowForm.showMiddle"
            prop="firstMiddleRepeatRate"
            label="90日以内(率)"
            width="110"
            align="right"
            :formatter="rateFormatter">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showRate && narrowForm.showLong"
            prop="firstLongRepeatRate"
            label="90日超過(率)"
            width="110"
            align="right"
            :formatter="rateFormatter">
          </el-table-column>
        </el-table-column>
        <el-table-column
          label="2回目来店"
          align="center">
          <el-table-column
            v-if="narrowForm.showCount"
            prop="secondVisitor"
            label="2回目来店合計"
            width="120"
            align="right">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showCount && narrowForm.showShort"
            prop="secondShortRepeat"
            label="45日以内"
            width="90"
            align="right">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showCount && narrowForm.showMiddle"
            prop="secondMiddleRepeat"
            label="90日以内"
            width="90"
            align="right">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showCount && narrowForm.showLong"
            prop="secondLongRepeat"
            label="90日超過"
            width="90"
            align="right">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showRate && narrowForm.showShort"
            prop="secondShortRepeatRate"
            label="45日以内(率)"
            width="110"
            align="right"
            :formatter="rateFormatter">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showRate && narrowForm.showMiddle"
            prop="secondMiddleRepeatRate"
            label="90日以内(率)"
            width="110"
            align="right"
            :formatter="rateFormatter">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showRate && narrowForm.showLong"
            prop="secondLongRepeatRate"
            label="90日超過(率)"
            width="110"
            align="right"
            :formatter="rateFormatter">
          </el-table-column>
        </el-table-column>
        <el-table-column
          label="3回以上来店"
          align="center">
          <el-table-column
            v-if="narrowForm.showCount"
            prop="manyVisitor"
            label="3回目以上合計"
            width="120"
            align="right">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showCount && narrowForm.showShort"
            prop="manyShortRepeat"
            label="45日以内"
            width="90"
            align="right">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showCount && narrowForm.showMiddle"
            prop="manyMiddleRepeat"
            label="90日以内"
            width="90"
            align="right">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showCount && narrowForm.showLong"
            prop="manyLongRepeat"
            label="90日超過"
            width="90"
            align="right">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showRate && narrowForm.showShort"
            prop="manyShortRepeatRate"
            label="45日以内(率)"
            width="110"
            align="right"
            :formatter="rateFormatter">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showRate && narrowForm.showMiddle"
            prop="manyMiddleRepeatRate"
            label="90日以内(率)"
            width="110"
            align="right"
            :formatter="rateFormatter">
          </el-table-column>
          <el-table-column
            v-if="narrowForm.showRate && narrowForm.showLong"
            prop="manyLongRepeatRate"
            label="90日超過(率)"
            width="110"
            align="right"
            :formatter="rateFormatter">
          </el-table-column>
        </el-table-column>
        <el-table-column
          prop="updatedAt"
          width="200"
          label="最終更新日">
          <template slot-scope="scope">
            {{ scope.row.updatedAt|printDateTime }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'

import ShopType from '@/consts/ShopType'
import downloadCsv from '@/misc/downloadCsv'

export default {
  name: 'AnalyticsIndex',
  filters: {
    printDate (val) {
      return moment(val).locale('ja').format('M/D (ddd)')
    },
    printRate (val) {
      return (Math.round(val * 1000) / 10) + '%'
    },
    printDateTime (val) {
      return moment(val).locale('ja').format('YYYY/MM/DD HH:mm:ss')
    },
  },
  data () {
    return {
      form: {
        targetMonth: null,
        toTargetMonth: null,
        multiple: false,
        shop: null,
      },
      narrowForm: {
        showRate: true,
        showCount: true,
        showShort: true,
        showMiddle: true,
        showLong: true,
      },
      isLoading: false,
      fromDate: null,
      toDate: null,
      dataAreaHeight: 600,
      items: [],
      groupPk: null,
      shops: [],
    }
  },
  computed: {
    dataAreaStyle () {
      return {
        'height': `${this.dataAreaHeight}px`,
      }
    },
  },
  created () {
    window.addEventListener('resize', this.setWindowHeight, false)
  },
  mounted () {
    this.form.targetMonth = moment().date(1)
    this.form.toTargetMonth = moment().date(1)
    this.fetchShops()
    this.setWindowHeight()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setWindowHeight, false)
  },
  methods: {
    fetchData (recalculate = false) {
      if (!this.form.shop) {
        return
      }
      if (this.form.multiple && !this.form.toTargetMonth) {
        return
      }

      let from = moment(this.form.targetMonth)
      let to = this.form.multiple ? moment(this.form.toTargetMonth) : moment(this.form.targetMonth)

      if (from > to) {
        const tmp = from
        from = to
        to = tmp
      }
      this.fromDate = from.clone()
      this.toDate = to.clone()
      this.shop = this.form.shop
      const f = async function () {
        while (from.diff(to, 'days') <= 0) {
          const year = from.year()
          const month = from.month() + 1
          await this.$request.analytics.nextVisitForMonth(year, month, this.form.shop, recalculate).then(res => {
            this.items.push(...res.body)
          })
          from = from.add(1, 'M')
        }
      }
      this.isLoading = true
      this.items = []
      f.bind(this)().then(() => {
      }).finally(() => {
        this.isLoading = false
      })
    },
    fetchShops () {
      this.$request.shops.list().then(res => {
        this.shops = res.body.results.filter(obj => obj.shopType === ShopType.SHOP)
        this.groupPk = res.body.results.find(obj => obj.shopType === ShopType.GROUP).pk
      })
    },
    rateFormatter (row, col, val) {
      return (Math.round(val * 1000) / 10) + '%'
    },
    getSummaries ({columns, data}) {
      let sums = []
      columns.forEach((column, index) => {
        const key = column.property
        if (key === 'date' || key === 'updatedAt' || key.endsWith('Rate')) {
          if (key === 'date') {
            sums.push('合計')
          } else {
            sums.push('')
          }
          return true
        }
        let sum = 0
        data.forEach(row => {
          sum += row[key]
        })
        sums.push(sum)
      })
      return sums
    },
    setWindowHeight: _.debounce(function () {
      this.dataAreaHeight = window.innerHeight - 250
    }, 300),
    download () {
      if (!this.items) {
        this.$message('データがありません．先に集計を対象を選択してください')
        return
      }
      let filename = '次回来店状況'
      if (this.form.multiple) {
        filename += moment(this.fromDate).locale('ja').format('YYYY年MM月') + '-' + moment(this.toDate).locale('ja').format('YYYY年MM月')
      } else {
        filename += moment(this.fromDate).locale('ja').format('YYYY年MM月')
      }
      filename += '_' + moment().format('YYYYMMDDHHmmss') + '.csv'
      const header = [
        '店舗',
        '日付',
        '予約数',
        'リピート率',
        '合計45日以内',
        '合計90日以内',
        '合計90日超過',
        '合計45日以内(率)',
        '合計90日以内(率)',
        '合計90日超過(率)',
        '初回来店合計',
        '初回来店45日以内',
        '初回来店90日以内',
        '初回来店90日超過',
        '初回来店45日以内(率)',
        '初回来店90日以内(率)',
        '初回来店90日超過(率)',
        '2回目来店合計',
        '2回目来店45日以内',
        '2回目来店90日以内',
        '2回目来店90日超過',
        '2回目来店45日以内(率)',
        '2回目来店90日以内(率)',
        '2回目来店90日超過(率)',
        '3回目以上合計',
        '3回目以上来店45日以内',
        '3回目以上来店90日以内',
        '3回目以上来店90日超過',
        '3回目以上来店45日以内(率)',
        '3回目以上来店90日以内(率)',
        '3回目以上来店90日超過(率)',
        '最終更新日',
      ]
      let data = []
      this.items.forEach(x => {
        const shop = this.shops.find(x => x.pk === this.shop)
        const shopName = shop ? shop.name : '全体'
        data.push([
          shopName,
          moment(x.date).locale('ja').format('M月D日'),
          x.reservationCount,
          x.repeatRate,
          x.shortRepeat,
          x.middleRepeat,
          x.longRepeat,
          x.shortRepeatRate,
          x.middleRepeatRate,
          x.longRepeatRate,
          x.firstVisitor,
          x.firstShortRepeat,
          x.firstMiddleRepeat,
          x.firstLongRepeat,
          x.firstShortRepeatRate,
          x.firstMiddleRepeatRate,
          x.firstLongRepeatRate,
          x.secondVisitor,
          x.secondShortRepeat,
          x.secondMiddleRepeat,
          x.secondLongRepeat,
          x.secondShortRepeatRate,
          x.secondMiddleRepeatRate,
          x.secondLongRepeatRate,
          x.manyVisitor,
          x.manyShortRepeat,
          x.manyMiddleRepeat,
          x.manyLongRepeat,
          x.manyShortRepeatRate,
          x.manyMiddleRepeatRate,
          x.manyLongRepeatRate,
          moment(x.updatedAt).locale('ja').format('YYYY/MM/DD HH:mm:ss'),
        ])
      })

      downloadCsv(filename, header, data, null)
    },
  },
}
</script>

<style scoped>
.data-area {
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Analytics/Index.vue